import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME, brandLogoSrc } from '../config/branding';
import { ChartIcon, DocumentIcon, BarChartIcon, CalendarIcon, DollarIcon, TargetIcon, RocketIcon, AlertTriangleIcon, ArrowLeftIcon, SparklesIcon } from '../components/Icons';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-hero">
          <div className="about-hero-brand">
            <img src={brandLogoSrc()} alt="" className="about-hero-logo" width={48} height={48} />
            <span className="about-hero-name">{APP_NAME}</span>
          </div>
          <h1 className="about-hero-title">서비스 소개</h1>
        </div>
        <p className="about-subtitle">투자 기록·포트폴리오·자산 관리를 한곳에서 시작하세요</p>
        
        <section className="about-section">
          <h2><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '6px' }}><ChartIcon size={20} color="currentColor" /></span> Tripistocka란?</h2>
          <p>
            Tripistocka는 개인의 투자 기록을 체계적으로 관리하고 분석할 수 있는 서비스입니다. 
            매수/매도 기록을 일지 형태로 남기고, 포트폴리오를 시각화하여 투자 성과를 한눈에 파악할 수 있습니다.
          </p>
        </section>

        <section className="about-section">
          <h2><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '6px' }}><SparklesIcon size={20} color="currentColor" /></span> 주요 기능</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><DocumentIcon size={32} color="currentColor" /></div>
              <h3>투자 기록 관리</h3>
              <p>
                매수/매도 기록을 날짜별로 관리하고, 
                투자 이유와 감상을 기록할 수 있습니다.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><BarChartIcon size={32} color="currentColor" /></div>
              <h3>포트폴리오 분석</h3>
              <p>
                보유 종목의 수익률, 손익을 실시간으로 계산하고, 
                포트폴리오 분산도를 분석합니다.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><CalendarIcon size={32} color="currentColor" /></div>
              <h3>캘린더 뷰</h3>
              <p>
                투자 기록이 있는 날짜를 캘린더에서 한눈에 확인하고, 
                날짜별 투자 내역을 조회할 수 있습니다.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><DollarIcon size={32} color="currentColor" /></div>
              <h3>자산 관리</h3>
              <p>
                고정 수입/지출을 관리하고, 월별 자산 변화를 추적하여 
                재무 계획을 세울 수 있습니다.
              </p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '6px' }}><TargetIcon size={20} color="currentColor" /></span> 서비스 목표</h2>
          <p>
            Tripistocka는 단순한 기록 도구를 넘어, 투자자들이 자신의 투자 패턴을 분석하고 
            개선할 수 있도록 돕는 것을 목표로 합니다. 체계적인 기록을 통해 더 나은 투자 결정을 내릴 수 있도록 지원합니다.
          </p>
        </section>

        <section className="about-section">
          <h2><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '6px' }}><RocketIcon size={20} color="currentColor" /></span> 시작하기</h2>
          <p>
            Tripistocka 서비스를 이용하려면 회원가입이 필요합니다. 
            무료로 가입하여 투자 기록 관리를 시작해보세요.
          </p>
          <div className="cta-buttons">
            <Link to="/register" className="cta-button primary">회원가입</Link>
            <Link to="/login" className="cta-button secondary">로그인</Link>
          </div>
        </section>

        <section className="about-section">
          <h2><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '6px' }}><AlertTriangleIcon size={20} color="currentColor" /></span> 투자 주의사항</h2>
          <div className="warning-box">
            <p>
              Tripistocka는 투자 기록을 관리하는 도구일 뿐, 투자 조언을 제공하지 않습니다. 
              모든 투자 결정은 본인의 판단과 책임 하에 이루어져야 하며, 
              투자에 따른 손실은 본인에게 귀속됩니다.
            </p>
            <p>
              투자는 신중하게 결정하시고, 본인의 투자 성향과 자금 상황을 고려하여 
              투자하시기 바랍니다.
            </p>
          </div>
        </section>

        <div className="about-footer">
          <Link to="/" className="back-link"><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '4px' }}><ArrowLeftIcon size={16} color="currentColor" /></span> 홈으로 돌아가기</Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;

